import PropTypes from 'prop-types'

import { getDisplayName, getUrlParam } from 'utils/mixpanel'

export const withAnalytics = (WrappedComponent) => {
  const Wrapper = (props) => {
    const {
      mixpanel,
      location,
      countSelectedStyleColors,
      countUnselectedStyleColors,
    } = props

    const trackers = {
      trackSubmitClicked: () =>
        mixpanel.track(
          'Remove Style Colors With No Quantities_Submit Clicked',
          {
            'Number of Style Colors Removed': countSelectedStyleColors,
            'Number of Style Colors Kept': countUnselectedStyleColors,
            ...getUrlParam(location),
          },
        ),
      trackReviewClicked: () =>
        mixpanel.track(
          'Remove Style Colors With No Quantities_Review Clicked',
          {
            'Number of Style Colors Removed': countSelectedStyleColors,
            'Number of Style Colors Kept': countUnselectedStyleColors,
            ...getUrlParam(location),
          },
        ),
      trackBackToOrdersClick: () =>
        mixpanel.track(
          'Remove Style Colors With No Quantities_Back To Orders Clicked',
          {
            ...getUrlParam(location),
          },
        ),
      trackPreviousPageClick: () =>
        mixpanel.track(
          'Remove Style Colors With No Quantities_Previous Page Clicked',
          {
            ...getUrlParam(location),
          },
        ),
    }

    return <WrappedComponent {...props} {...trackers} />
  }

  Wrapper.propTypes = {
    mixpanel: PropTypes.object,
    location: PropTypes.object.isRequired,
  }
  Wrapper.defaultProps = {
    mixpanel: { track: () => {} },
  }

  Wrapper.displayName = `withAnalytics(${getDisplayName(WrappedComponent)})`
  return Wrapper
}

export default withAnalytics
